import { NgClass } from '@angular/common';
import { Component, ElementRef, input, SimpleChanges, signal, viewChild } from '@angular/core';
import { I18nPipe } from '@bbitgmbh/website.sdk';

@Component({
  selector: 'app-read-more',
  imports: [NgClass, I18nPipe],
  templateUrl: './read-more.component.html',
  styleUrl: './read-more.component.scss',
})
export class ReadMoreComponent {
  public html = input('');
  public isCollapsed = signal(true);
  public showReadMore = signal(false);
  public textContainer = viewChild<ElementRef>('textContainer');

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['html']) {
      setTimeout(() => this.checkOverflow(), 0);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.checkOverflow(), 0);
  }

  toggle() {
    this.isCollapsed.set(!this.isCollapsed());
  }

  private checkOverflow() {
    const el = this.textContainer()?.nativeElement;
    if (el) {
      this.showReadMore.set(el.scrollHeight > el.clientHeight);
    }
  }
}
